<template>
    <div class="diagram-detail">
        <!-- 1. 顶部吸顶部分 -->
        <diagram-detail-top-panel></diagram-detail-top-panel>
        <!-- 2. 主要内容部分 -->
        <div class="diagram-detail-main-content">
            <diagram-detail-edit-panel></diagram-detail-edit-panel>
        </div>
        <!-- 3. 底部扫码 -->
        <div class="diagram-detail-note">
            <div class="diagram-detail-note-content">
                <div class="diagram-detail-qrcode">
                    <qrcode class="diagram-detail-note-img" id="dQrImg" tag="img" :options="{size: 300, padding: 0}" :value="qrCodeValue" :quality="1" ></qrcode>
                    <i class="iconbg icon-qr-logo"></i>
                </div>
            </div>
        </div>

        <!-- 图片弹框 -->
        <van-image-preview v-if="diagramData" v-model="showDetailImgPanel" :images="diagramData.f_fb_img_arr" @change="onFBImgChange" :start-position="diagramDetailChoosedImgIndex"></van-image-preview>

        <!-- 删除提示弹框 -->
        <delete-record-item-pop></delete-record-item-pop>
    </div>
</template>

<script>
import DiagramDetailTopPanel from '../../layouts/diagram/DiagramDetailTopPanel.vue';
import DiagramDetailEditPanel from '../../layouts/diagram/DiagramDetailEditPanel.vue';
import DeleteRecordItemPop from '../../layouts/popup/DeleteRecordItemPop.vue'
import { DIAGRAM_DOM } from '../../modules/dom';
export default {
    name: 'DiagramDetail',
    components: {DiagramDetailTopPanel, DiagramDetailEditPanel, DeleteRecordItemPop },
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        diagramTitle() {
            return this.$store.state.diagram.diagramTitle;
        },
        diagramBaseInfo() {
            return this.$store.state.diagram.diagramBaseInfo;
        },
        diagramDetailInfo() {
            return this.$store.state.diagram.diagramDetailInfo;
        },
        diagramData() {
            return this.$store.state.diagram.diagramData;
        },
        diagramFromShare() {
            return this.$store.state.diagram.diagramFromShare;
        },
        qrCodeValue() {
            return this.$store.state.diagram.qrCodeValue;
        },
        showDetailImgPanel: {
            get() {
                return this.$store.state.diagram.showDetailImgPanel;
            },
            set(value) {
                this.$store.state.diagram.showDetailImgPanel = value;
            }
        },
        diagramDetailChoosedImgIndex() {
            return this.$store.state.diagram.diagramDetailChoosedImgIndex;
        },

    },
    data() {
        return {
            qrCode: require('../../assets/images/qrcode.png'),
        }
    },
    mounted: function() {
        if(location.pathname.indexOf('share') == -1 && (this.diagramBaseInfo == null || this.diagramDetailInfo == null)) {
            let curPath = this.$router.history.current.path;
            let fullPath = this.$router.history.current.fullPath;
            if(curPath.indexOf('embedded') != -1) {
                let pathArr = curPath.split('/').filter(text => {return text!=''&&text!='embedded'});
                let replaceText = '/'+pathArr.join('/');
                fullPath = fullPath.replace(replaceText, '/diagramrecord');
                this.$router.replace(fullPath);
                setTimeout(() => {
                    window.location.reload();
                }, 10);
            }else {
                this.$router.replace('/diagramrecord');
            }
        }
        if(location.pathname.indexOf('share') >= 0) {
            setTimeout(() => {
                if(this.diagramBaseInfo == null || this.diagramDetailInfo == null) {
                    this.$router.replace('/diagramrecord');
                    return;
                }
                if(this.diagramData.uid == this.userData.uid) {
                    return;
                }
                setTimeout(() => {
                    this.$store.dispatch('diagram/autoSaveSharedDiagram', {
                        sucCb: ()=>{
                            this.$toast('卦已经自动保存到列表中');
                            this.$router.replace('/diagramdetail/'+this.diagramData.id)
                        },
                        failCb: ()=>{
                            this.$toast('卦已经保存过了');
                            console.error('卦已经保存过了');
                        }
                    });
                }, 1000);
            }, 1000);
        }
        DIAGRAM_DOM.updateDiagramDetailStyle();
    },
    methods: {
        onFBImgChange() {
            console.log('onFBImgChange')
        }
    }
}
</script>
